// Tracks in-flight API requests so <GlobalLoader /> can show the
// water-drop overlay while the portal is waiting on the server.
// A request can opt out with `{ silent: true }` in its axios config.
let pending = 0;
const listeners = new Set();
const emit = () => listeners.forEach((fn) => fn(pending));

export const loaderBus = {
  start() { pending += 1; emit(); },
  stop() { pending = Math.max(0, pending - 1); emit(); },
  subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); },
};

// Attach start/stop to an axios instance (both the shared instance in
// api.js and the default axios used directly by a few pages).
export const attachLoader = (instance) => {
  instance.interceptors.request.use((config) => {
    if (!config.silent) { config.__loader = true; loaderBus.start(); }
    return config;
  });
  const done = (config) => { if (config && config.__loader) loaderBus.stop(); };
  instance.interceptors.response.use(
    (res) => { done(res.config); return res; },
    (err) => { done(err.config); return Promise.reject(err); }
  );
};
